export interface IProductDiscountInfo {
  positionId: string;
  discountSum: number;
  amount: number;
  programmId: string;
}

export interface IDiscountProgrammInfo {
  id: string;
  name: number;
}

export interface IDiscountWarning {
  code: string;
  message: number;
}

export interface IOrderDiscountInfo {
  productDiscounts: IProductDiscountInfo[];
  programms: IDiscountProgrammInfo[];
  totalDiscount: number;
  freeProductExternalIds: string[];
  warnings: IDiscountWarning[];
}

export enum PromoCodeStatus {
  NotChecked = 0,
  Correct = 1,
  InCorrect = 2,
}

// если купон невалидный, то при расчете скидки вместе с рассчитанной скидкой [IOrderDiscountInfo](по параметрам IikoCard например),
// придет массив warnings с элементом,
// имеющим ниже указанный код
export const WrongCouponNumberCode = 'WrongCouponNumber';
